<template>
  <div
    v-if="show && airport"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ airport.name }}</h3>
          <p class="customer-popup-subtitle">Airport Details</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <!-- Airport Information -->
        

        <!-- Runways Information -->
        <div v-if="hasRunways" class="customer-popup-section">
          <h4 class="customer-popup-section-title">Runways</h4>
          
          <div class="airport-runways-table">
            <table>
              <thead>
                <tr>
                  <th style="color: var(--foreground) !important;">Low End</th>
                  <th style="color: var(--foreground) !important;">High End</th>
                  <th style="color: var(--foreground) !important;">Length (ft)</th>
                  <th style="color: var(--foreground) !important;">Width (ft)</th>
                  <th style="color: var(--foreground) !important;">Surface</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(runway, index) in airport.runways" :key="index">
                  <td>{{ runway.le_ident || '-' }}</td>
                  <td>{{ runway.he_ident || '-' }}</td>
                  <td>{{ formatNumber(runway.length_ft) }}</td>
                  <td>{{ formatNumber(runway.width_ft) }}</td>
                  <td>{{ runway.surface || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div v-if="airnavUrl" class="airport-link-container">
            <a :href="airnavUrl" target="_blank" class="customer-popup-link">
              View on AirNav →
            </a>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AirportPopup',
  
  props: {
    airport: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    hasRunways() {
      return this.airport && this.airport.runways && this.airport.runways.length > 0;
    },
    
    airnavUrl() {
      if (!this.airport) return null;
      const identifier = this.airport.identifier || this.airport.iata_code || this.airport.code;
      return identifier ? `https://www.airnav.com/airport/${identifier}` : null;
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    },
    
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '-';
      return parseInt(value).toLocaleString();
    }
  }
};
</script>
